"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PiwikAnalyticsService = void 0;
const analytics_event_enum_1 = require("./analytics-event.enum");
const piwik_min_js_1 = __importDefault(require("./scripts/piwik.min.js"));
class PiwikAnalyticsService {
    logEvent(category, extraParams) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: category }, extraParams));
    }
    logAPIError(message, statusCode, statusMessage) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: analytics_event_enum_1.AnalyticsEvent.API_ERROR,
            apiMessage: message,
            apiResponseStatusCode: statusCode,
            apiResponseStatusMessage: statusMessage
        });
    }
    logUIError(message) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: analytics_event_enum_1.AnalyticsEvent.UI_ERROR,
            uiMessage: message
        });
    }
    static initializePiwikScripts(piwikConfig) {
        if (!piwikConfig || !piwikConfig.trackingCode || !piwikConfig.url) {
            throw new Error("Missing Piwik configuration to initialize scripts");
        }
        piwik_min_js_1.default(window, document, "dataLayer", piwikConfig.url, piwikConfig.trackingCode);
    }
}
exports.PiwikAnalyticsService = PiwikAnalyticsService;
//# sourceMappingURL=piwik-analytics.service.js.map